import { render, staticRenderFns } from "./CompetitionHolder.vue?vue&type=template&id=c9ab2efe&"
import script from "./CompetitionHolder.vue?vue&type=script&lang=js&"
export * from "./CompetitionHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports